export default __webpack_public_path__ + "static/supply-demand-457ac239208fea6b1bc69ca5af28ceef.png";